// Per-tab credentials: never share/overwrite a customer's ordinary AW session.
const KEY = 'aw_support_session';
const MODE = 'aw_support_mode';
const NATIVE = 'aw_support_native';
export const isSupportTab = () => sessionStorage.getItem(MODE) === 'true';
export const isNativeSupportTab = () => isSupportTab() && sessionStorage.getItem(NATIVE) === 'true';
export const beginSupportTab = (native = false) => {
  sessionStorage.setItem(MODE, 'true');
  sessionStorage.setItem(NATIVE, String(native));
  sessionStorage.removeItem(KEY);
};
export const saveSupportSession = (session) => {
  if (!/^awsup\.[A-Za-z0-9_-]{43}$/.test(session?.support_token || '') || !session.tenant_id) {
    throw new Error('Invalid support session response');
  }
  sessionStorage.setItem(MODE, 'true');
  sessionStorage.setItem(NATIVE, String(session.native_workspace === true));
  sessionStorage.setItem(KEY, JSON.stringify(session));
};
export const endSupportTab = () => {
  // Preserve the marker so late requests/reloads cannot become customer requests.
  sessionStorage.setItem(MODE, 'true');
  sessionStorage.removeItem(KEY);
  window.dispatchEvent(new Event('aw-support-ended'));
};
export const readSupportSession = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); }
  catch { return null; }
};

export async function supportRequest(path, { code, close = false } = {}) {
  if (!/^\/(context|executions(?:\/[a-zA-Z0-9-]+)?(?:\?offset=\d+)?|exchange|close)$/.test(path)) {
    throw new Error('Unsupported support operation');
  }
  const base = process.env.REACT_APP_BACKEND_URL;
  if (!base) throw new Error('ActionWeave API origin is not configured');
  const session = readSupportSession();
  const headers = code ? { 'Content-Type': 'application/json' } : {
    'X-AW-Support-Session': session?.support_token || 'ended',
    ...(session?.tenant_id ? { 'X-Tenant-ID': session.tenant_id } : {}),
  };
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  let response;
  try { response = await fetch(`${base}/api/v1/auth/support${path}`, {
    method: code || close ? 'POST' : 'GET', headers,
    body: code ? JSON.stringify({ code }) : undefined,
    credentials: 'omit', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer',
    signal: controller.signal,
  }); } finally { clearTimeout(timeout); }
  if (response.status === 401 || response.status === 403) {
    endSupportTab();
    throw new Error('Support access ended, expired, or was revoked. Open a new session from Support.');
  }
  if (!response.ok) throw new Error('Support access is unavailable. No customer actions were submitted.');
  return response.json();
}
